const totalDataSummary = (data) => {
    return data.reduce((prev, { total }) => {
        return prev + total
    }, 0)
}

export default totalDataSummary